import { ReactComponent as Fund } from '../../../res/svg/black-fund-cc.svg';
import { ReactComponent as Flag } from '../../../res/svg/flag-cc.svg';
import { ReactComponent as ChevronRight } from '../../../res/svg/chevron-right.svg';
import { ReactComponent as CapasDisabled} from '../../../res/svg/capas-disabled.svg';
import { ReactComponent as Excel } from '../../../res/svg/excel-file.svg';
import './SectionIndicator.less';

interface SubSection {
  sectionName: 'Administración' | 'Gestor de Tareas' | 'Gestor de Capas' | 'Gestor de Registros',
  key: string;
  label: string;
  icon: JSX.Element;
}

export const subsections: { [key: string]: SubSection } = {
  tiposTarea: {
    sectionName: 'Administración',
    key: 'admin/tipos-tareas',
    label: 'Tipos de Tareas',
    icon: <Fund />,
  },
  roles: {
    sectionName: 'Administración',
    key: 'admin/roles',
    label: 'Roles',
    icon: <Fund />,
  },
  usuarios: {
    sectionName: 'Administración',
    key: 'admin/usuarios',
    label: 'Usuarios',
    icon: <Fund />,
  },
  tareas: {
    sectionName: 'Gestor de Tareas',
    key: 'tareas',
    label: 'Tareas',
    icon: <Flag />,
  },
  reportes: {
    sectionName: 'Gestor de Tareas',
    key: 'reportes',
    label: 'Reportes e Informes',
    icon: <Flag />,
  },
  gestorCapas:{
    sectionName: 'Gestor de Capas',
    key: 'gestor-de-capas',
    label: 'Importador de Capas',
    icon: <CapasDisabled />, 
  },
  gestorRegistros:{
    sectionName: 'Gestor de Registros',
    key: 'gestor-de-registros',
    label: 'Importador XLSX',
    icon: <Excel />, 
  }
};


type Sections = 'Gestor de Tareas' | 'Administración' | 'Gestor de Capas' | 'Gestor de Registros';
type SubSections = 'Tipos de Tareas' | 'Roles' | 'Usuarios';

interface Props {
  subsection: SubSection;
}

function SectionIndicator({ subsection }: Props) {
  return (
    <div className={'ml-section-indicator__container'}>
      <div className={'ml-section-indicator__icon-container'}>
        {subsection.icon}
      </div>
      <div className={'ml-section-indicator__section'}>
        {subsection.sectionName}
      </div>
      <ChevronRight />
      <div className={'ml-section-indicator__subsection'}>
        {subsection.label}
      </div>
    </div>
  );
}

export default SectionIndicator;
